module.exports = __webpack_public_path__ + "img/icon-next.f983cb06.png";